import { ForwardedRef, forwardRef } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { LabeledCheckbox, LabeledCheckboxProps } from "../forms/checkbox";
import { FormField, TFormField } from "./form-field";

export type CheckboxFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = TFormField<TFieldValues, TFieldPath> &
  Omit<LabeledCheckboxProps, "children" | "onCheckedChange">;

export const CheckboxFormField = forwardRef(function CheckboxFormField<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  { label, ...props }: CheckboxFormFieldProps<TFieldValues, TFieldPath>,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <FormField {...props}>
      {(field) => (
        <LabeledCheckbox
          ref={ref}
          {...props}
          {...field}
          label={label}
          onCheckedChange={(checked) =>
            field.onChange({ target: { value: checked } })
          }
        />
      )}
    </FormField>
  );
});
